import { InjectionToken } from '@angular/core';

export const CIPAFACIL_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('CIPAFACIL_MOCK_API_DEFAULT_DELAY');
